import { getTokenFromLegacyConfig, parseLegacyOptions } from './legacy-support';

export function parseConfig ({options, legacyConfig}) {
  const config = {
    legacyConfig: parseLegacyOptions(legacyConfig),
    options
  };

  // If we're not given a token explicitly try to pull one out of our legacyConfig.
  if (!options.bearerToken) {
    options.bearerToken = getTokenFromLegacyConfig(legacyConfig);
  }

  return config;
}



// WEBPACK FOOTER //
// ./src/viewer/core/instance/config/parse-config.js